<template>
  <div class="view-container">
    <section class="section-container">
      <TabComponent :tabItems="tabItems" @changeValue="changeValue" />
      <div class="assets-container">
        <div class="left-content">
          <TableComponent
            :data="table.data"
            :tableData="table"
            @onRowSelected="selectedRow">
            <div slot="table-top" class="lg-6">
              <AssetsDialogComponent
                @changeValue="updateAsset"
                @updateTable="changeValue"
                :assetType="defaultTabName"
                ref="assetdialog" />
            </div>
          </TableComponent>
        </div>
        <div class="right-content">
          <p>Preview {{ defaultTabName.toLowerCase() }}</p>
          <div v-if="fileName && defaultTabName === 'Image'">
            <img
              class="image-src"
              :src="`data:image/jpg;base64,${fileBuffer}`" />
          </div>
          <div v-if="fileName && defaultTabName === '3D model'">
            <RotatingProduct
              :stop="true"
              :radio="radioObject"
              :radioName="fileName"
              prefix="3D model"
              :isStatic="false" />
          </div>
          <div v-if="fileName && defaultTabName === 'Datasheet'">
            <iframe
              class="pdf-src"
              :src="`data:application/pdf;base64,${fileBuffer}`"></iframe>
          </div>
          <div v-if="fileName && (defaultTabName === 'Colorcode' || defaultTabName === 'Ortho')" class="colorcode-content">
            <img
              class="colorcode-src"
              :src="`data:image/png;base64,${fileBuffer}`" />
          </div>
          <div v-if="fileName && defaultTabName === 'Slides'">
            <img
              class="colorcode-src"
              :src="`data:image/jpg;base64,${fileBuffer}`" />
          </div>
          <div v-if="fileName && defaultTabName === 'Video' && videoSrc !== ''">
            <video :src="videoSrc" class="w-100" controls />
          </div>
        </div>
      </div>
    </section>
    <ConfirmationDialogComponent
      v-if="showDialog"
      :isUsed="isUsed"
      :isEdit="isEdit"
      :products="products"
      :removeFile="removeFile"
      :removalFileId="removalFileId"
      :removeType="defaultTabName"
      :open="showDialog"
      :assetCreateModel="assetCreateModel"
      @close="closeDialog" />
  </div>
</template>

<script>
import TabComponent from '../base.component/TabComponent.vue';
import TableComponent from './TableComponent.vue';
import RotatingProduct from '../rotatingProduct.vue';
import AssetsDialogComponent from './AssetsDialogComponent.vue';
import ConfirmationDialogComponent from '../base.component/ConfirmationDialogComponent.vue';
import { Dropdown } from '@eds/vanilla';
import AssetsApiService from '@/services/assetsServices/assetsApiService';
import AssetsService from '@/services/assetsServices/assetsService';
import ProductService from '@/services/productService';
import { ASSET_TYPES, ASSET_TYPES_BE } from '@/constants/assets';

export default {
  components: {
    TabComponent,
    TableComponent,
    RotatingProduct,
    AssetsDialogComponent,
    Dropdown,
    ConfirmationDialogComponent,
  },

  data() {
    return {
      files: [],
      table: {},
      fileName: null,
      defaultTabName: ASSET_TYPES.MODEL,
      radioObject: {
        rotatingProductSettings: {
          alpha: '1.6',
          beta: '1.5',
        },
      },
      slides: [],
      delete: null,
      edit: null,
      showDialog: false,
      componentName: '',
      removeType: '',
      removeFile: '',
      removalFileId: '',
      isUsed: false,
      isEdit: false,
      products: [],
      fileBuffer: [],
      assetCreateModel: {},
      tabItems: [],
      videoSrc: ''
    };
  },

  created() {
    this.initDataTable();
    this.getTabName();
  },

  watch: {
    defaultTabName: function () {
      this.table.data = AssetsService.getAssetsByType();
      this.initDataTable();
    },
  },

  methods: {
    getTabName() {
      for(let item in ASSET_TYPES) {
        this.tabItems.push({
          name: ASSET_TYPES[item],
          isActive: false,
        })
      }
    },

    initDataTable() {
      let dropdowns = [];
      this.table = {
        data: AssetsService.getAssetsByType(),
        columns: [
          {
            key: 'fileId',
            title: 'ID',
            searchable: true,
            selected: true,
          },
        ],
        onCreatedActionsCell: (td, data) => {
          const dropdownDOM = this.createActionMenu();
          td.append(dropdownDOM);

          const dropdown = new Dropdown(dropdownDOM);
          dropdown.init();

          this.delete.addEventListener('click', () => this.deleteAsset(data));
          this.edit.addEventListener('click', () => this.editAsset(data));
          dropdowns.push(dropdown);
        },
        beforeCreatedBody: () => {
          dropdowns.forEach((d) => d.destroy());
          dropdowns = [];
        },
        selectable: 'single',
        rowsPerPage: '15',
      };
    },

    async selectedRow(selected) {
      if (selected.length > 0) {
        this.fileName = selected[0].path;

        if (this.defaultTabName != ASSET_TYPES.MODEL && this.defaultTabName !== ASSET_TYPES.VIDEO)
        {
          this.fileBuffer = await AssetsApiService.getAssetFile(this.fileName);
        }

        if (this.defaultTabName === ASSET_TYPES.VIDEO) {
          this.videoSrc = await AssetsApiService.getVideoUrl(selected[0].path)
        }
      } else {
        this.fileName = null;
        this.fileBuffer = null;
        this.videoSrc = null;
      }
    },

    createActionMenu() {
      const markup = `
      <div class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div id="edit" class="item">Replace</div>
          <div id="delete" class="item">Remove</div>
        </div>
      </div>`;

      const template = document.createElement('template');
      template.innerHTML = markup.trim();

      this.delete = template.content.getElementById('delete');
      this.edit = template.content.getElementById('edit');

      return template.content.firstChild;
    },

    async changeValue(name) {
      const filter = {
        assetsType: name === ASSET_TYPES.MODEL ? ASSET_TYPES_BE.MODEL : name,
      };

      await AssetsApiService.getAssetsByType(filter);

      this.table.data = AssetsService.getAssetsByType();
      this.initDataTable();

      this.defaultTabName = name;
    },

    editAsset(data) {
      this.products = [];
      ProductService.getProducts().forEach((product) => {
        if (product[this.setProperty(data.type)] === data.path
          || (data.type === ASSET_TYPES_BE.VIDEO && product[this.setProperty(data.type)]?.fileName === data.path)) {
          const productName = `${product.productId} - ${
            product.isMana ? 'MANA' : 'Global'
          }`;
          this.products.push(productName);
        } else if (data.type === ASSET_TYPES_BE.SLIDES
                  && product[this.setProperty(data.type)].includes(data.path)) {
          const productName = `${product.productId} - ${product.isMana ? 'MANA' : 'Global'}`;
          this.products.push(productName);
        }
      });

      const assetdialog = this.$refs.assetdialog;
      const children = assetdialog.$el.children;

      assetdialog.asset = data;
      assetdialog.isEdit = true;
      assetdialog.products = this.products;

      children[0].click();
    },

    deleteAsset(data) {
      this.products = [];
      ProductService.getProducts().forEach((product) => {
        if (product[this.setProperty(data.type)] === data.path
          || (data.type === ASSET_TYPES_BE.VIDEO && product[this.setProperty(data.type)]?.fileName === data.path)) {
          const productName = `${product.productId} - ${
            product.isMana ? 'MANA' : 'Global'
          }`;
          this.products.push(productName);
        } else if (data.type === ASSET_TYPES_BE.SLIDES
                  && product[this.setProperty(data.type)].includes(data.path)) {
          const productName = `${product.productId} - ${product.isMana ? 'MANA' : 'Global'}`;
          this.products.push(productName);
        }
      });

      this.isUsed = this.products.length > 0;

      this.removalFileId = data.id;
      this.removeFile = data.path;
      this.removeType = data.type;
      this.showDialog = !this.showDialog;
    },

    closeDialog() {
      this.changeValue(this.defaultTabName);
      this.showDialog = !this.showDialog;
      this.isUsed = false;
      this.isEdit = false;
    },

    setProperty(assetType) {
      switch (assetType) {
        case ASSET_TYPES_BE.MODEL: {
          return 'modelFileName';
        }
        case ASSET_TYPES_BE.IMAGE: {
          return 'landscapeImagePath';
        }
        case ASSET_TYPES_BE.DATASHEET: {
          return 'dataSheetFilePath';
        }
        case ASSET_TYPES_BE.COLORCODE: {
          return 'colorCodeImagePath';
        }
        case ASSET_TYPES_BE.SLIDES: {
          return 'slides';
        }
        case ASSET_TYPES_BE.ORTHO: {
          return 'orthoPath';
        }
        default:
          return 'video';
      }
    },

    changeFile(name) {
      this.showDialog = !this.showDialog;
      this.isUsed = true;
      this.isEdit = true;
    },

    updateAsset(assetCreateModel) {
      this.assetCreateModel = assetCreateModel;

      this.showDialog = true;
      this.isUsed = true;
      this.isEdit = true;

    }
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';

.view-container {
  overflow: scroll;
  padding-top: 0.25rem;
}

.assets-container {
  display: flex;
}

.section-container {
  padding: @space-base @space-large;
  width: 95vw;
}

.left-content {
  width: 30%;
  border-right: 1px solid;
  padding: 1rem;
}

.right-content {
  width: 70%;
  padding: 1rem;
}

.image-src {
  max-height: 90%;
  max-width: 100%;
  margin-top: 1rem;
}

.pdf-src {
  height: 80vh;
  width: 70vw;
  margin-top: 1rem;
}

.colorcode-src {
  height: 80vh;
  margin-top: 1rem;
}

.colorcode-content {
  text-align: center;
}

.w-100 {
  width: 100%;
}
</style>